import {useEffect, useState} from "react";
import './App.css';
import Spiegazione from './Spiegazione';

import axios from 'axios';

function App() {
    /*
    CLIENT ID       --> ID della mia applicazione react registrata sul portale di Spotify for Developers (posso trovarlo nella dashboard qui: https://developer.spotify.com/dashboard/)
    REDIRECT_URI    --> URL con il quale vado a visualizzare la mia app (di default è il localhost sulla porta 3000)
    AUTH_ENDPOINT   --> Pagina di autenticazione di Spotify
    RESPONSE_TYPE   --> TOKEN per l'autenticazione
    */
    const CLIENT_ID = "46c318244df94bcbb67ef86ce832ee2c"
    const REDIRECT_URI = "http://localhost:3000"
    const AUTH_ENDPOINT = "https://accounts.spotify.com/authorize"
    const RESPONSE_TYPE = "token"

    //useState per la memorizzazione del token, della chiave di ricerca e dei risultati degli artisti
    const [token, setToken] = useState("")
    const [searchKey, setSearchKey] = useState("")
    const [artists, setArtists] = useState([])

    //useEffect per il settaggio del token
    useEffect(() => {
        const hash = window.location.hash
        let token = window.localStorage.getItem("token")

        if (!token && hash) {
            token = hash.substring(1).split("&").find(elem => elem.startsWith("access_token")).split("=")[1]
            window.location.hash = ""
            window.localStorage.setItem("token", token)
        }

        setToken(token)

    }, [])

    //LOGOUT --> disconnette e rimanda alla pagina di accesso
    const logout = () => {
        //Il token viene impostato come stringa vuota e viene rimosso dal local storage
        setToken("")
        window.localStorage.removeItem("token")
    }

    //CERCA ARTISTA --> richiama l'API per la ricerca
    const cercaArtista = async (e) => {
        e.preventDefault()
        const {data} = await axios.get("https://api.spotify.com/v1/search", {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                q: searchKey,
                type: "artist"
            }
        })
        //salvo i dati nello useState "Artists"
        setArtists(data.artists.items)
    }

    //MOSTRA ARTISTA --> crea i <div> con le informazioni riguardo l'artista cercato
    const mostraArtista = () => {
        console.log(artists)
        return artists.map(artist => (
            <div className='row'>
                {/* Immagine */}
                <div class="datiArtista">{artist.images.length ? <img width={"100%"} src={artist.images[0].url} alt=""/> : <div class="col-12">No image<i class="fa fa-sort-amount-desc" aria-hidden="true"></i></div>}</div>
                {/* Nome */}
                <div class="col-4 datiArtista">Artista: {artist.name}</div>
                {/* Popolarità */}
                <div class="col-4 datiArtista">Popolarità: {artist.popularity}%</div>
                {/* Followers */}
                <div class="col-4 datiArtista">Followers: {artist.followers.total}</div>
                {/* Generi (titolo) */}
                <div class="col-4 linkArtista">Generi:</div>
                {/* Generi (map) */}
                {artist.genres.map(genere => (
                    <div class="col-4 datiArtista">·{genere}</div>
                ))}
                {/* Link a Spotify */}
                <div class="col-4 linkArtista"><a href={artist.external_urls.spotify} target="new">VISUALIZZA IN APP</a></div>
            </div>
        ))
    }

    //RETURN --> STAMPA A VIDEO
    return (
        <div className="App">
            <header className="App-header">

                {/* TITOLO */}
                <h1><font color="#1DD460">4C Bracco Mattia</font></h1>
                <h2>React JS ~ Spotify Artists Search</h2>

                {/* BUTTON PER IL LOGUT */}
                {!token ?
                    <a href={`${AUTH_ENDPOINT}?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=${RESPONSE_TYPE}`}><font color="#1DD460">Login to Spotify</font></a>
                    : <button className="buttonLogout" onClick={logout}>LOGOUT</button>}
                <Spiegazione />
                {/* INPUT PER LA RICERCA */}
                {token ?
                    <form onSubmit={cercaArtista}>
                        {/* Casella di testo */}
                        <input type="text" className="textCerca" placeholder="Inserire un artista" onChange={e => setSearchKey(e.target.value)}/>
                        {/* Button */}
                        <button type={"submit"} className="buttonSearch">SEARCH</button>
                    </form>
                    //scritta mostrata se è necessarrio effettuare il login
                    : <h2><font color="red">È NECESSARIO EFFETTUARE IL LOGIN!</font></h2>
                }

                {mostraArtista()}

            </header>
        </div>
    );
}

export default App;
